import React, { ReactNode, useMemo } from 'react';
import AccordionContext, { AccordionContextType } from '@/components/accordion/context/AccordionContext';

export interface AccordionProps extends AccordionContextType {
  children?: ReactNode;
}

const Accordion = ({ open, toggle, children, ...props }: AccordionProps) => {
  const context = useMemo(() => ({ open, toggle }), [open, toggle]);

  return <AccordionContext.Provider value={context}>{children}</AccordionContext.Provider>;
};

export default Accordion;
